import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { 
  Icon, 
  Button} from  'semantic-ui-react'
import ReactTable from 'react-table'

import { Cont } from './styled'
import {StdForm} from '../../../components'
import { 
  initialRoleMan } from '../../../ducks/roleMan'
import {
  columns } from '../AttributeData'
import FormRoleModal from '../FormRoleModal'
import FormPermissionModal from '../FormPermissionModal'
import FormPermissionRoleModal from '../FormPermissionRoleModal'
import UserRolesSection from './UserRolesSection'

import r from 'reactotron-react-js'

const RoleMan = (props) => {
  const {
    roles,
    permissions,
    showModal,
    setShowModal,
    modalData,
    setModalData,
    modalTitle,
    setModalTitle,
    modalIsCreate,
    setModalIsCreate,
    roleId,
    setRoleId } = props

  return (
    <Cont>
      <UserRolesSection/>
      <div style={{height:'1rem'}}/>
      <StdForm fitContent={false} title={
        <div>
          Role
          <Icon link circular inverted color='teal' name='add' size='small' style={{marginLeft:'1rem'}} onClick={()=>showRoleModal(true,null)}/>
        </div>
      } style={{width:'80vw'}} enableCollapse>
        <ReactTable 
          data={roles&&roles}
          columns={columns.tRole}
          pageSize={10}
          previousText='previous'
          nextText='next'
          className="-striped -highlight"
          SubComponent={row => {
            return (
              <div style={{padding:'1rem',width:'70vw'}}>
                <Button
                  onClick={()=>showPermissionRoleModal(true,null,row.original.id)} 
                  positive
                  labelPosition='right'
                  icon='add'
                  content='Add'
                />
                <div style={{height:'1rem'}}/>
                <ReactTable
                  data={row.original.permission}
                  columns={columns.tPermissionRole}
                  defaultPageSize={5}
                  getTdProps={(state, rowInfo,column,instance) => {
                    if(column.Header){
                      return {
                        onClick: (e, handleOriginal) => {
                          if(rowInfo&&column.Header){
                            showPermissionRoleModal(false,rowInfo.original,0)
                          }
                        },
                      }
                    }else{
                      return {}
                    }
                  }}
                />
              </div>
            )
          }}
          getTdProps={(state, rowInfo,column,instance) => {
            if(column.Header){
              return {
                onClick: (e, handleOriginal) => {
                  if(rowInfo&&column.Header){
                    showRoleModal(false,rowInfo.original)
                  }
                },
              }
            }else{
              return {}
            }
          }}
        />
      </StdForm>
      <div style={{height:'1rem'}}/>
      <StdForm fitContent={false} title={
        <div>
          Permission
          <Icon link circular inverted color='teal' name='add' size='small' style={{marginLeft:'1rem'}} onClick={()=>showPermissionModal(true,null)}/>
        </div>
      } style={{width:'80vw'}} enableCollapse>
        <ReactTable 
          data={permissions&&permissions}
          columns={columns.tPermission}
          pageSize={10}
          previousText='previous'
          nextText='next'
          className="-striped -highlight"
          getTdProps={(state, rowInfo,column,instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if(rowInfo){
                  showPermissionModal(false,rowInfo.original)
                }
              },
            }
          }}
        />
      </StdForm>
      <FormRoleModal 
        title={modalTitle}
        data={modalData}
        isCreate={modalIsCreate}
        show={showModal.role} 
        changeShow={()=>setShowModal({...showModal,role:!showModal.role})}/>
      <FormPermissionModal 
        title={modalTitle}
        data={modalData}
        isCreate={modalIsCreate}
        show={showModal.permission} 
        changeShow={()=>setShowModal({...showModal,permission:!showModal.permission})}/>
      <FormPermissionRoleModal 
        title={modalTitle}
        roleId={roleId}
        data={modalData}
        isCreate={modalIsCreate}
        show={showModal.permissionRole} 
        changeShow={()=>setShowModal({...showModal,permissionRole:!showModal.permissionRole})}/>
    </Cont>
  )

  function showRoleModal(isCreate,data){
    if(isCreate){
      setModalIsCreate(true)
      setModalTitle('Create Role')
      setModalData(null)
    }else{
      setModalIsCreate(false)
      setModalTitle('Update Role')
      setModalData(data)
    }
    setShowModal({...showModal,role:true})
  }

  function showPermissionModal(isCreate,data){
    if(isCreate){
      setModalIsCreate(true)
      setModalTitle('Create Permission')
      setModalData(null)
    }else{
      setModalIsCreate(false)
      setModalTitle('Update Permission')
      setModalData(data)
    }
    setShowModal({...showModal,permission:true})
  }

  function showPermissionRoleModal(isCreate,data,roleId){
    setRoleId(roleId)
    if(isCreate){
      setModalIsCreate(true)
      setModalTitle('Add Permission To Role')
      setModalData(null)
    }else{
      setModalIsCreate(false)
      setModalTitle('Update Permission Of Role')
      setModalData(data)
    }
    setShowModal({...showModal,permissionRole:true})
  }
  
}

const mapStateToProps = (state) => ({
  roles : state.roleMan.roles,
  permissions : state.roleMan.permissions,
})

const mapDispatchToProps = {
  initialRoleMan
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showModal','setShowModal',{role:false,permission:false,permissionRole:false}),
  withState('modalIsCreate','setModalIsCreate',false),
  withState('modalData','setModalData',null),
  withState('modalTitle','setModalTitle',''),
  withState('roleId','setRoleId',0),
  lifecycle({
    componentDidMount() {
      this.props.initialRoleMan()
    },
    componentWillReceiveProps(nextProp) { }
  })
)

export default enhance(RoleMan)
